import { VStack, Text, Box } from '@wegroup/design-system';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/redux/reducers/rootReducer';
import SelectedOfferTextArea from './SelectedOfferTextArea';
import {
  setCustomerSheet,
  setReasonOfContact as setReasonOfContactAction,
} from '../../store/redux/slices/offersSlice';

const OfferInfoInputs: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const customerSheet = useSelector(
    (state: RootState) => state.offers.offersInfo.customerSheet,
  );
  const [knowOurOffice, setKnowOurOffice] = useState<string>(customerSheet);
  const [reasonOfContact, setReasonOfContact] = useState<string>('');

  return (
    <VStack spacing="4" width="100%" mt="14" align="stretch">
      <Box>
        <Text textStyle="h4Headline" mb="6">
          {t('How do you know our office')}
        </Text>
        <SelectedOfferTextArea
          name="knowOurOffice"
          value={knowOurOffice}
          placeholder={t('You can leave this empty if this remains unknown')}
          onChange={(value) => setKnowOurOffice(value)}
          onBlur={() => dispatch(setCustomerSheet(knowOurOffice))}
        />
      </Box>

      <Box>
        <Text textStyle="h4Headline" mb="6">
          {t('Reason for contact')}
        </Text>
        <SelectedOfferTextArea
          name="reasonOfContact"
          value={reasonOfContact}
          placeholder={t(
            'Is there a specific reason why you choose to contact your broker? If not, you can leave this empty',
          )}
          onChange={(value) => setReasonOfContact(value)}
          onBlur={() => dispatch(setReasonOfContactAction(reasonOfContact))}
        />
      </Box>
    </VStack>
  );
};

export default OfferInfoInputs;
